import React from "react";
import { Link } from "react-router-dom";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";

/**
 * Point d'entrée pour la gestion des paramètres de paiement (pays, méthodes, frais).
 */
const PaymentSettingsHub = () => {
  const cards = [
    {
      title: "Pays de paiement",
      description:
        "Liste des pays et activation des méthodes par marché (cocher / décocher).",
      to: "/payment-countries",
      action: "Gérer les pays",
      icon: "icon-globe",
    },
    {
      title: "Méthodes de paiement",
      description:
        "Catalogue des méthodes : support payin/payout, plateformes, pays associés, canaux et liaisons provider.",
      to: "/payment-methods",
      action: "Voir les méthodes",
      icon: "icon-credit-card",
    },
    {
      title: "Providers",
      description:
        "Partenaires techniques de paiement : priorité, statut, configuration API et suppression.",
      to: "/payment-providers",
      action: "Gérer les providers",
      icon: "icon-shield",
    },
  ];

  return (
    <div className="container-fluid">
      <AppBreadcrumb title="Paramètres de paiement" />

      <div className="card p-4 bg-white text-dark mb-4">
        <h5 className="mb-2">Configuration des paiements</h5>
        <p className="text-muted mb-0">
          Centralisez la configuration métier : disponibilité par pays (page{" "}
          <strong>Activer des méthodes</strong>), référentiel des méthodes et des{" "}
          <strong>providers</strong>. L’application appelle l’API customer care (
          <code>/payment-methods</code>, <code>/payment-providers</code>, etc.).
        </p>
      </div>

      <div className="row">
        {cards.map((card) => (
          <div key={card.to} className="col-md-4 mb-4">
            <div className="card h-100 border-0 shadow-sm">
              <div className="card-body d-flex flex-column">
                <div className="d-flex align-items-center mb-3">
                  <span
                    className={`${card.icon} mr-2`}
                    style={{ fontSize: "1.5rem", color: "#5c6bc0" }}
                    aria-hidden
                  />
                  <h6 className="mb-0">{card.title}</h6>
                </div>
                <p className="text-muted small flex-grow-1">{card.description}</p>
                <Link to={card.to} className="btn btn-primary btn-sm mt-2">
                  {card.action}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentSettingsHub;
